(function () {
  'use strict';

  angular
    .module('web2print')
    .filter('printFollowingDays', printFollowingDays);

  function printFollowingDays ($filter) {
    return printFollowingDaysFilter;

    ////////////////

    function printFollowingDaysFilter (days) {

      const followingDays = [];

      for (let i = 0; i < days.length; i++) {
        const day = days[i];

        const followingDaysArray = findArrayWithPreviousDaysForDay(followingDays, day);

        if (followingDaysArray !== undefined) {
          followingDaysArray.push(day);
        } else {
          followingDays.push([day]);
        }
      }

      const res = _.map(followingDays, function (dayArray) {
        let dayString = $filter('translate')(_.first(dayArray).name.toUpperCase());
        dayString += (dayArray.length > 1)
          ? ' - ' + $filter('translate')(_.last(dayArray).name.toUpperCase())
          : '';
        return dayString;
      }).join(', ');

      return res;
    }

    function findArrayWithPreviousDaysForDay (followingDays, day) {
      return _.find(followingDays, function (array) {
        return _.find(array, function (d) {

          return moment().day(d.name).day() === (((moment().day(day.name).day() -1) +7) %7);
        });
      });
    }
  }
})();
